<script setup>
import PdfViewer from '@templates/pdfViewer/PdfViewer.vue';
import { url } from '@/config/urls';
import { useRoute } from 'vue-router';

const route = useRoute();
const splitSiteCode = route.query.splitSiteCode ?? null;
const filename = route.query.filename ?? '';

const allowedFiles = ['enif_club_apply.pdf', 'enif_club_bank.pdf'];
const safeFilename = allowedFiles.includes(filename) ? filename : '';

const titleMap = {
  'enif_club_apply.pdf': '利用申込書',
  'enif_club_bank.pdf': '預金口座振替依頼書',
};
const title = titleMap[safeFilename] ?? 'ENIF-club書類';
</script>

<template>
  <PdfViewer
    :title="title"
    :api-url="url.api.enifClubDocument.pdf"
    :params="{ splitSiteCode, filename: safeFilename }"
  />
</template>